import { COMMAND_CENTER_ROOT } from './commandCenterRoutes'
import { useNavigate } from 'react-router-dom'
import { OperationsHome } from './operations'

/**
 * V2 Operations home — route wrapper.
 *
 * Registered standalone + auth-gated (see router.tsx):
 *   /square/command-center/operations
 *
 * The Operations command deck: every card opens an internal V2 mini portal at
 * /operations/<id>. Wires real navigation (Q home → dashboard, back → command
 * center, card → module portal). SSR-safe; the home component is presentational.
 */
export default function SquareCodeOperationsRoute() {
  const navigate = useNavigate()
  return (
    <OperationsHome
      onOpenModule={(path) => navigate(path)}
      onBackCommandCenter={() => navigate(COMMAND_CENTER_ROOT)}
      onHome={() => navigate(COMMAND_CENTER_ROOT)}
    />
  )
}
